// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__MeGX2","header":"MergedInvoice_header__2MafW"};